// Logs once per page load when the visitor arrived from an AI assistant.
import { useEffect, useRef } from "react";
import { useLocation } from "@tanstack/react-router";
import { detectAiReferral, extractQuestionParam } from "@/lib/ai-crawlers/detect";
import { recordAiReferralVisit } from "@/lib/ai-crawlers/referral.functions";
import { getAnonymousId } from "@/lib/identity/anonymousId";
import { track } from "@/lib/customer-intelligence/tracker";

export function AiReferralTracker() {
  const location = useLocation();
  const logged = useRef<string | null>(null);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const path = window.location.pathname;
    if (logged.current === path) return;

    const referrer = document.referrer || "";
    const search = window.location.search || "";
    const assistant = detectAiReferral(referrer, search);
    if (!assistant) return;

    logged.current = path;
    void recordAiReferralVisit({
      data: {
        assistant,
        referrer: referrer.slice(0, 500) || null,
        path: path.slice(0, 500),
        query: search ? search.slice(1, 501) : null,
        question: extractQuestionParam(search),
        anonymousId: getAnonymousId() || null,
        userAgent: navigator.userAgent.slice(0, 400),
      },
    }).catch(() => {
      /* ignore */
    });
    // Also surface the arrival in Visitor Journeys.
    track("ai_referral_arrival", { assistant, path });
  }, [location.pathname]);

  return null;
}
